@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.districtButtonModal {
  margin-bottom: variables.$std-margin-lg;
}
